import React from 'react';
import get from 'lodash/get';

import './CheckOption.css';


const Component = props => (
  <div styleName={get(props, 'styles.main') || 'main'}>
    <div>
      <input
        styleName="checkBox"
        type="checkbox"
        onChange={props.onChange}
        checked={props.checked}
      />
    </div>
    <div styleName="textBlock">
      { props.children }
    </div>
  </div>
);

Component.displayName = 'CheckOption';

export default Component;



// WEBPACK FOOTER //
// ./src/components/Invest/components/CheckOption.js